import { weekdays } from "@lib/constants/general";
import i18n from "@lib/i18n";

export function parseValue(
  value: string | number | undefined | null,
  defaultValue: string = "-"
): string {
  return value ? `${value}` : defaultValue;
}

export const getDaysLabel = (selectedDays: number[]) => {
  if (selectedDays !== undefined && selectedDays?.length === 0) {
    return "-";
  }

  const sortedDays = [...selectedDays].sort((a, b) => a - b); // Sort the days in ascending order

  if (sortedDays.length === 7) {
    return i18n.t("user.bindings.daily"); // If all days are selected
  } else if (
    sortedDays.length === 2 &&
    sortedDays.includes(5) &&
    sortedDays.includes(6)
  ) {
    return i18n.t("user.bindings.everyWeekend"); // If Saturday and Sunday are selected
  } else if (
    sortedDays.length === 5 &&
    sortedDays.every((day) => day >= 0 && day <= 4)
  ) {
    return i18n.t("user.bindings.everyWeekday"); // If only weekdays (0-4) are selected
  } else if (sortedDays.length === 1) {
    return weekdays[sortedDays[0]]; // Show single day if only one is selected
  } else {
    return sortedDays.map((day) => weekdays[day]).join(", "); // Display the selected weekdays in order
  }
};
